module.exports = __webpack_public_path__ + "img/banner-bg.e53906e6.jpg";